import { createContext } from 'react';
import { IFlowBuilder2PageContext } from './FlowBuilder2PageContext.types';

export const FlowBuilder2PageContext = createContext<IFlowBuilder2PageContext | null>(null);
